import React, { useState } from "react";
import { Box, Toolbar, Container } from "@mui/material";
import { Outlet } from "react-router-dom";
import AppHeader from "./AppHeader";
import AppFooter from "./AppFooter";
import AppSidebar, { SIDEBAR_WIDTH } from "./AppSidebar";

export default function AppLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundColor: "background.default",
      }}
    >
      <AppHeader onMenuToggle={() => setMobileOpen((prev) => !prev)} />
      <AppSidebar
        mobileOpen={mobileOpen}
        onClose={() => setMobileOpen(false)}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          ml: { xs: 0, md: `${SIDEBAR_WIDTH}px` },
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Toolbar />
        <Box sx={{ flexGrow: 1, p: { xs: 2, md: 3 } }}>
          <Container maxWidth="xl" disableGutters>
            <Outlet />
          </Container>
        </Box>
        <AppFooter />
      </Box>
    </Box>
  );
}
